import clsx from 'clsx';
import { BasicProductData } from 'components/layout/modals/compatible-combinations-browser-modal';
import EquipmentPlaceholderPhoto from 'components/products/equipment-placeholder-photo';
import { productImageUrl } from 'utils/system-products';
import { combinationComponentImages } from './combination-component-images';
import ProductImageTile from './product-image-tile';

type CombinationComponentImageStripProps = Readonly<{
  combination: Record<string, unknown>;
  productData: Record<string, BasicProductData>;
  className?: string;
}>;

export default function CombinationComponentImageStrip({
  combination,
  productData,
  className
}: CombinationComponentImageStripProps) {
  const images = combinationComponentImages(combination, productData);
  if (images.length === 0) return null;

  return (
    <div className={clsx('flex items-center gap-2', className)}>
      {images.map((image) => (
        <ProductImageTile key={image.key}>
          {image.photo ? (
            <img
              src={productImageUrl(image.photo)}
              alt={image.alt}
              className='h-full w-full object-contain'
            />
          ) : (
            <EquipmentPlaceholderPhoto
              kind={image.placeholderKind}
              size='medium'
              bare
            />
          )}
        </ProductImageTile>
      ))}
    </div>
  );
}
